import HTMLElementWrapper from './HTMLElementWrapper';
import { TEST } from '../../../constants';

const DEFAULT_QUALITY = 0.92;
const dataURL = TEST
  ? 'data:image/webp'
  : document.createElement('canvas').toDataURL('image/webp');
const IS_WEBP_SUPPORTED = TEST || dataURL.startsWith('data:image/webp');

const LOSSY_TYPE_SUFFIX = IS_WEBP_SUPPORTED ? 'webp' : 'jpg';
const LOSSLESS_TYPE_SUFFIX = IS_WEBP_SUPPORTED ? 'webp' : 'png';

class CanvasElementWrapper extends HTMLElementWrapper {
  constructor() {
    super('canvas');
    this.context = this.element.getContext('2d');
    this.dataURLs = new Map();
  }

  setDimensions({ width, height }) {
    this.element.width = width;
    this.element.height = height;
  }

  setPixels(videoWrapper, scale = 1.0) {
    const { height, width } = videoWrapper.getDimensions();
    const scaledHeight = height * scale;
    const scaledWidth = width * scale;
    this.setDimensions({ width: scaledWidth, height: scaledHeight });
    this.context.drawImage(
      videoWrapper.getElement(),
      0,
      0,
      width,
      height,
      0,
      0,
      scaledWidth,
      scaledHeight,
    );
    this.dataURLs = new Map();
  }

  getDataURL(quality) {
    const qualityKey = `q_${quality || DEFAULT_QUALITY}`;

    if (!this.dataURLs.has(qualityKey)) {
      const type = `image/${
        quality ? LOSSLESS_TYPE_SUFFIX : LOSSY_TYPE_SUFFIX
      }`;
      const dataURL = this.element.toDataURL(type, quality);
      this.dataURLs.set(qualityKey, dataURL);
    }

    return this.dataURLs.get(qualityKey);
  }
}

export default CanvasElementWrapper;
